import { action, select } from 'satcheljs/lib/legacy';
import { default as viewStateStore } from '../store/store';
/*
 * Sets state to spawn a context menu attached to a MailFolderList folder.
*/
export var showFolderTreeContextMenu = select({
    folderTreeViewState: function () { return viewStateStore; },
})(action('showFolderTreeContextMenu')(function (nodeId, nodeType, folder, anchor, treeType, state) {
    // VSO 13261: Refactor the showHideContextMenu to only takes in the folderId
    state.folderTreeViewState.withContextMenuFolderId = folder.FolderId.Id;
    state.folderTreeViewState.contextMenuState = {
        nodeId: nodeId,
        nodeType: nodeType,
        folder: folder,
        anchor: anchor,
        treeType: treeType,
    };
}));
/*
 * Sets state to close the context menu attached to a MailFolderList folder.
*/
export var hideFolderTreeContextMenu = select({
    folderTreeViewState: function () { return viewStateStore; },
})(action('hideFolderTreeContextMenu')(function (state) {
    state.folderTreeViewState.withContextMenuFolderId = null;
    state.folderTreeViewState.contextMenuState = null;
}));
//# sourceMappingURL=folderTreeContextMenu.js.map